import { DevelopSummary } from "../widgets/developSummary/developSummary.js";

let fdDevelopContainer = document.getElementById('fdDevelopContainer');
let opts = {};
let fdDevelopSummaryWidget = new DevelopSummary(fdDevelopContainer, opts);